export default "__VITE_ASSET__a7f306a8__"